import { useState } from "react";
import { TopBar } from "@/components/layout";
import ThreadList from "@/components/threads/ThreadList";
import ThreadDetail from "@/components/threads/ThreadDetail";
import NewThreadForm from "@/components/threads/NewThreadForm";

type View = "list" | "detail" | "new";

const ThreadsPage = () => {
  const [view, setView] = useState<View>("list");
  const [selectedThreadId, setSelectedThreadId] = useState<string | null>(null);

  const handleSelectThread = (threadId: string) => {
    setSelectedThreadId(threadId);
    setView("detail");
  };

  const handleBack = () => {
    setSelectedThreadId(null);
    setView("list");
  };

  const handleNewThread = () => {
    setView("new");
  };

  const handleThreadCreated = () => {
    setView("list");
  };

  return (
    <>
      <TopBar title="Pomysly" />
      <div className="flex-1 overflow-auto p-6">
        <div className="max-w-3xl mx-auto">
          {view === "list" && (
            <ThreadList
              onSelectThread={handleSelectThread}
              onNewThread={handleNewThread}
              selectedThreadId={selectedThreadId}
            />
          )}

          {view === "detail" && selectedThreadId && (
            <ThreadDetail threadId={selectedThreadId} onBack={handleBack} />
          )}

          {view === "new" && (
            <NewThreadForm onBack={handleBack} onCreated={handleThreadCreated} />
          )}
        </div>
      </div>
    </>
  );
};

export default ThreadsPage;
